import React from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import { fr } from 'date-fns/locale';

const HolidayClock = ({ currentTime, theme }) => {
  const getThemeStyles = () => {
    switch (theme) {
      case 'christmas':
        return {
          gradient: 'from-red-500 via-green-500 to-red-500',
          shadow: 'shadow-red-500/20',
          border: 'border-green-400/30'
        };
      case 'winter':
        return {
          gradient: 'from-blue-400 via-cyan-300 to-blue-400',
          shadow: 'shadow-blue-500/20',
          border: 'border-blue-400/30'
        };
      case 'new-year':
        return {
          gradient: 'from-yellow-400 via-purple-500 to-pink-500',
          shadow: 'shadow-purple-500/20',
          border: 'border-yellow-400/30'
        };
      case 'hanukkah':
        return {
          gradient: 'from-blue-600 via-white to-blue-600',
          shadow: 'shadow-blue-600/20',
          border: 'border-blue-500/30'
        };
      default:
        return {
          gradient: 'from-red-500 via-green-500 to-red-500',
          shadow: 'shadow-red-500/20',
          border: 'border-green-400/30'
        };
    }
  };

  const styles = getThemeStyles();

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.5 }}
      className={`mb-12 p-8 rounded-3xl backdrop-blur-md bg-white/10 border ${styles.border} ${styles.shadow} shadow-2xl`}
    >
      <div className="text-center">
        <motion.div
          animate={{ 
            backgroundPosition: ['0% 50%', '100% 50%', '0% 50%']
          }}
          transition={{ 
            duration: 3, 
            repeat: Infinity, 
            ease: "easeInOut" 
          }}
          className={`text-6xl md:text-8xl font-bold bg-gradient-to-r ${styles.gradient} bg-clip-text text-transparent mb-4`}
          style={{ backgroundSize: '200% 200%' }}
        >
          {format(currentTime, 'HH:mm:ss')}
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="text-xl md:text-2xl text-white/80 font-light capitalize"
        >
          {format(currentTime, 'EEEE d MMMM yyyy', { locale: fr })}
        </motion.div>
      </div>

      {/* Decorative elements */}
      <div className="absolute -top-2 -left-2 w-4 h-4 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-full animate-pulse" />
      <div className="absolute -top-2 -right-2 w-4 h-4 bg-gradient-to-br from-pink-400 to-purple-500 rounded-full animate-pulse delay-300" />
      <div className="absolute -bottom-2 -left-2 w-4 h-4 bg-gradient-to-br from-green-400 to-blue-500 rounded-full animate-pulse delay-700" />
      <div className="absolute -bottom-2 -right-2 w-4 h-4 bg-gradient-to-br from-red-400 to-pink-500 rounded-full animate-pulse delay-1000" />
    </motion.div>
  );
};

export default HolidayClock;